import React, { useEffect, useState } from 'react';
import VideoModal from '../components/VideoModal'
import websso from '../assets/images/Vectorwebsso.png'
import sync from '../assets/images/Vectorsync.png'
import social from '../assets/images/Vectorsocial.png'
import selfService from '../assets/images/VectorselfService.png'
import progressive from '../assets/images/Vectorprogressive.png'
import Passwordless from '../assets/images/Vectorpasswordless.png'

import sso from '../assets/images/Vectorsso.png'
import mfa from '../assets/images/Vectormfa.png'
import network from '../assets/images/Vectornetwork.png'
import lifecycle from '../assets/images/Vectorlifecycle.png'
import vpn from '../assets/images/Vectorvpn.png'
import brokering from '../assets/images/Vectorbrokering.png'
import adaptive from '../assets/images/Vectoradaptive.png'
import YouTube from 'react-youtube';
import { AiFillPieChart, AiOutlineAudit, AiOutlineClockCircle, AiOutlinePieChart } from "react-icons/ai";
import { MdOutlineFingerprint, MdOutlineVerifiedUser, MdOutlineVideoCameraFront, MdVerifiedUser } from 'react-icons/md';


const PamDemo = () => {

  const [open, setOpen] = useState(false);
  const [demoData, setDemoData] = useState();
  const handleOpen = (videoData) => {
    setDemoData(videoData);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const opts = {
    height: '337',
    width: '100%',
    playerVars: {
      //   https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      rel: 0
    },
  };

  const playPause = (event) => {
    // Remove the immediate pause - let the video play
    console.log("Video is ready");
  }

  const pamData = [
    {
      title: "Auditing & Reporting",
      video: true,
      videoId: "hkWXNmMKCWU",
      videoType: "youtube",
      icon: <AiOutlineAudit className='text-white fs-5' />
    },
    {
      title: "JIT Privileged Access",
      video:true,
      videoId: "MOtvgDNRVzo",
      videoType: "youtube",
      icon: <AiOutlineClockCircle className='text-white fs-5' />
    },
    {
      title: "Multi-Factor Authentication",
      video: true,
      videoId: "J5OZfmxEFXs",
      videoType: "youtube",
      icon: <MdOutlineFingerprint className='text-white fs-5' />
    },
    {
      title: "Session Recording & Monitoring",
      video: true,
      videoId: "pVi_H5dmD-Q",
      videoType: "youtube",
      icon: <MdOutlineVideoCameraFront className='text-white fs-5' />
    },
  ]

  return (
    <>
      <div className='w-100 py-3' style={{ height: '88vh', overflowX:'hidden' }}>
        <div className='mx-2 h-auto'>
          <div className='backButton d-flex align-items-center' onClick={() => window.history.back()}>
            <span class="material-symbols-rounded text-dark">
              keyboard_arrow_left
            </span>
            <p className='mb-0'>Back to main page</p>
          </div>
        </div>
        <h4 className='text-center mt-2 h-auto lh-base text-secondary-emphasis fw-bold mx-4 mx-md-0 mt-4 mt-md-0'>Privileged Access Management</h4>
        <h5 className='text-center mb-md-3 h-auto text-secondary'>Where access is a privilege, not a right</h5>
        <div className='row justify-content-center h-75 align-items-center mx-md-5 my-lg-5'>
          <div className='col-12'>
            <div className='row justify-content-between'>
              <div className='col-6 d-flex align-items-center justify-content-center d-md-flex d-none'>
                <div className='col-12 col-xl-10'>
                  <YouTube className='w-100' videoId="hJ-VFWBxZdA" opts={opts} onReady={playPause} />
                </div>
              </div>

              <div className='col-md-6 col-12 d-flex justify-content-center'>
                <div className='row justify-content-start px-5' style={{height:'fit-content'}}>
                  {pamData?.map((item) => {
                    if(item.video == false){
                    return (
                      <div className={pamData.length <=6 ? "col-md-12 ms-4 ms-md-0 ms-lg-4 py-1 col-sm-5 px-lg-5 px-0" : "col-lg-5 col-md-12 ms-4 ms-md-0 ms-lg-4 py-1 col-sm-5"}>
                        <div className='d-flex justify-content-start'>
                          <div className='p-2 d-flex align-items-center'>
                            <div className="align-items-center text-14">
                              <div className="d-flex justify-content-center bg-primary align-items-center me-3 rounded-circle" style={{height: "40px", width: "40px"}} >
                                  {item.icon}
                              </div>
                            </div>
                            <div>
                                <span style={{fontWeight:500, fontSize:'17px'}}>
                                    {item.title}
                                </span>
                            </div>
                        </div>
                        </div>
                      </div>
                    )}
                    else{
                      return (
                        <div className={pamData.length <=6 ? "col-md-12 ms-4 ms-md-0 ms-lg-4 py-1 col-sm-5 px-0 px-lg-5" : "col-lg-5 col-md-12 ms-4 ms-md-0 ms-lg-4 py-1 col-sm-5"}>
                          <div className='d-flex justify-content-start'>
                            <div className='p-2 d-flex align-items-center service-button' onClick={() => handleOpen({ "text": item.title, "videoId": item.videoId, "videoType": item.videoType })} style={{ width: 'fit-content' }}>
                              <div className="align-items-center text-14">
                                <div className="d-flex justify-content-center bg-primary align-items-center me-3 rounded-circle" style={{height: "40px", width: "40px"}} >
                                    {item.icon}
                                </div>
                              </div>
                              <div>
                                  <span style={{fontWeight:500, fontSize:'17px'}}>
                                      {item.title}
                                  </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    }
                  })}

                </div>
              </div>
            </div>
          </div>
        </div>


      </div>
      <VideoModal
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        videoData={demoData}
      />
    </>
  )
}

export default PamDemo